// FILE: src/pages/ProfilePage.jsx

import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Avatar,
  CircularProgress,
} from "@mui/material";
import API from "../api";

export default function ProfilePage() {
  // Local state for user profile fields
  const [displayName, setDisplayName] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [currentProfilePic, setCurrentProfilePic] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch user profile on component mount
  useEffect(() => {
    fetchUserProfile();
  }, []);

  async function fetchUserProfile() {
    try {
      setLoading(true);
      // Call the endpoint that returns the current user's profile.
      // Ensure your backend has the GET /users/me route.
      const res = await API.get("/users/me");
      const user = res.data;
      setDisplayName(user.displayName || "");
      // If your backend returns a signed URL for private images, use that;
      // otherwise, this could be a public URL.
      setCurrentProfilePic(user.signedProfileUrl || "");
    } catch (err) {
      console.error("fetchUserProfile error:", err);
      alert("Failed to load profile. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  async function handleSaveProfile() {
    try {
      // Create a FormData object to hold text fields and the file upload.
      const formData = new FormData();
      formData.append("displayName", displayName);
      if (profileImage) {
        formData.append("profileImage", profileImage);
      }

      // PUT the updated profile to your backend.
      await API.put("/users/update-profile", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Profile updated successfully!");

      // Force a full page refresh to update all UI data
      window.location.reload();
    } catch (error) {
      console.error("handleSaveProfile error:", error);
      alert("Failed to update profile. Please try again.");
    }
  }

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 400, mx: "auto", p: 2 }}>
      <Typography variant="h5" mb={2}>
        My Profile
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
        {currentProfilePic ? (
          <Avatar src={currentProfilePic} sx={{ width: 100, height: 100 }} />
        ) : (
          // Fallback avatar using the first letter of the display name or a default "U"
          <Avatar sx={{ width: 100, height: 100 }}>
            {displayName ? displayName.charAt(0).toUpperCase() : "U"}
          </Avatar>
        )}
      </Box>
      <TextField
        label="Display Name"
        fullWidth
        value={displayName}
        onChange={(e) => setDisplayName(e.target.value)}
        sx={{ mb: 2 }}
      />
      <Button variant="outlined" component="label" sx={{ mb: 2 }}>
        Upload New Profile Picture
        <input
          type="file"
          accept="image/*"
          hidden
          onChange={(e) => {
            if (e.target.files && e.target.files[0]) {
              setProfileImage(e.target.files[0]);
            }
          }}
        />
      </Button>
      {profileImage && (
        <Typography variant="body2" sx={{ mb: 2 }}>
          Selected file: {profileImage.name}
        </Typography>
      )}
      <Button variant="contained" onClick={handleSaveProfile}>
        Save Profile
      </Button>
    </Box>
  );
}
